module.exports = __webpack_public_path__ + "static/media/main_parent@2x.08422a7d.png";